
import { MessageSquare } from "lucide-react";
import { SocialActionButton } from "./SocialActionButton";

interface CommentButtonProps {
  count: number;
  onClick: () => void;
  buttonSize: string;
  iconSize: number;
  theme: string;
  canComment: boolean;
}

export function CommentButton({
  count,
  onClick,
  buttonSize,
  iconSize,
  theme,
  canComment
}: CommentButtonProps) {
  const getCommentColor = () => {
    return theme === 'dark' ? "hover:bg-blue-400/5" : "hover:bg-blue-50";
  };

  return (
    <SocialActionButton
      onClick={onClick}
      icon={
        <MessageSquare
          className="mr-1.5 transition-transform"
          size={iconSize}
        />
      }
      count={count}
      tooltipText={canComment ? "Voir et ajouter des commentaires" : "Voir les commentaires"}
      buttonSize={buttonSize}
      colorClasses={getCommentColor()}
      iconSize={iconSize}
    />
  );
}
